export default __webpack_public_path__ + "6683cfd9100edc5c5f44b7249017ef5b.png";